<template>
  <div class="swiper_con">
	<div 
	v-if="tokenStr"
	:class="navBarFixed == true ? 'navBarWrap' :''"
	style="-moz-box-shadow:2px 2px 10px #CCC;
	-webkit-box-shadow:2px 2px 10px #CCC;
	box-shadow:2px 2px 10px #CCC;">
	<div class="pc">
	<el-menu
text-color="#000000"
	:default-active="$route.path"
	active-text-color="#409EFF"
	height="500px"
	mode="horizontal"
	@select="handleSelect"
	router
	>
	<!-- 左侧的 logo -->

		
	<div class="left">
	<img src="../assets/img/zhongxuan.png" alt=""  class="ZHimg"/>
	<div class="lefttext">
		<span class="logostyle">上海中烜国际物流有限公司</span>
		<span  class="ywmz">SHANGHAI ZHONGXUAN INTERNAITIONAL LOGISTICS CO.LTD.</span>
	</div>
	</div>
	
	

	  <el-menu-item index="/home" class="right">{{$t('m.HomeText')}}</el-menu-item>
	  <el-submenu index="/yunjia" class="right">
	    <template slot="title">{{$t('m.yjcx')}}</template>
	    <el-menu-item index="/fclbysea">{{$t('m.hyzx')}}</el-menu-item>
	    <el-menu-item index="/lclbysea">{{$t('m.hypx')}}</el-menu-item>
	    <el-menu-item index="/byair">{{$t('m.ky')}}</el-menu-item>
			<el-menu-item index="/railroad">{{$t('m.t.tl')}}</el-menu-item>
			<el-menu-item index="/trailer">{{$t('m.t.nltc')}}</el-menu-item>
			<el-menu-item index="/express">{{$t('m.t.gjkd')}}</el-menu-item>
	  </el-submenu>
	   <el-menu-item index="/entrustment" class="right">{{$t('m.t.wtjl')}}</el-menu-item>
	  <el-menu-item index="/us" class="right">{{$t('m.CompanyText')}}</el-menu-item>
	  <el-menu-item index="/contact" class="right">{{$t('m.Contact')}}</el-menu-item>
	 
	
	
	<!-- 后台管理系统 -->
	<el-submenu index="" v-if="menusChildren.length>=1 && menusChildren[0].Fid !== null" class="right">
	    <template slot="title">{{$t('m.htglxt')}}</template>
		<template v-for="item in menusChildren">
	    <el-menu-item
	    :index="item.indexPath"
	    :key="item.indexPath"
		v-if="item.children.length===0"
		>{{item.label}}
		</el-menu-item>
		
		<el-submenu
		:index="item.indexPath"
		:key="item.indexPath"
		v-else
		>
		<template slot="title">{{item.label}}</template>
		<el-menu-item
		:key="subItem.indexPath"
		:index="subItem.indexPath" 
		v-for="subItem in item.children" >
		{{subItem.label}}
		</el-menu-item>
		</el-submenu>
		</template>
	  </el-submenu>
	  <!-- 个人中心 -->
	  <el-submenu index="grzx" class="right">
	     <template slot="title">
	        <span>{{$t('m.grzx')}}</span>
	      </template>
	  <el-menu-item index="/userAllInfo"
	     ><i class="el-icon-s-operation"></i>{{$t('m.myCenterText')}}
		 </el-menu-item
	   >
	     <el-menu-item index="/userInfo"
	        ><i class="el-icon-edit-outline"></i>{{$t('m.xgMyInfo')}}</el-menu-item
	      >
	      <el-menu-item index="/userAvatar"
	        ><i class="el-icon-camera"></i>{{$t('m.ghtx')}}</el-menu-item
	      >
	      <el-menu-item index="/userPwd"
	        ><i class="el-icon-key"></i>{{$t('m.zzmm')}}</el-menu-item
	      >
	    </el-submenu> 
	    <!--  <img :src="this.user_pic" alt="" class="avatar" /> -->
	  
	  <el-menu-item   @click="logout" class="right"><i class="el-icon-switch-button"></i>{{$t('m.out')}}</el-menu-item>
	  
	  <div style="padding: 20px;" class="right">
	  		  <el-dropdown @command="handleCommand">
	  		    <span class="el-dropdown-link">
	  		    {{language}}<i class="el-icon-arrow-down el-icon--right"></i>
	  		    </span>
	  		    <span class="el-dropdown-link">
	  		     
	  		    </span>
	  		    <el-dropdown-menu slot="dropdown">
	  		      <el-dropdown-item command="zh-CN">{{zhOption}}</el-dropdown-item>
	  		      <el-dropdown-item command="en-US">{{enOption}}</el-dropdown-item>
	  		    </el-dropdown-menu>
	  		  </el-dropdown>
	  		  </div>
			  
			   
			   
			<div class="right1">
							 <div style="font-size:30px; color: black;" @click="isCollapseClick">
							 <i class="el-icon-s-unfold"></i>
							 </div>
							  </div>
			   
			   
			   
			   
			   
	</el-menu>
	      </div>
	</div>
<!-- 没有登录 -->	
<div 
v-else
:class="navBarFixed == true ? 'navBarWrap' :''"
	style="-moz-box-shadow:2px 2px 10px #CCC;
	-webkit-box-shadow:2px 2px 10px #CCC;
	box-shadow:2px 2px 10px #CCC;">
	
	<div class="pc">
	<el-menu
text-color="#000000"
	:default-active="$route.path"
	active-text-color="#409EFF"
	height="500px"
	mode="horizontal"
	@select="handleSelect"
	router
	>
	<!-- 左侧的 logo -->

		
	<div class="left">
	<img src="../assets/img/zhongxuan.png" alt=""  class="ZHimg"/>
	<div class="lefttext" >
		<span class="logostyle">上海中烜国际物流有限公司</span>
		<span  class="ywmz">SHANGHAI ZHONGXUAN INTERNAITIONAL LOGISTICS CO.LTD.</span>
	</div>
</div>


	  <el-menu-item index="/home" class="right">{{$t('m.HomeText')}}</el-menu-item>
	  <el-submenu index="/yunjia" class="right">
	    <template slot="title">{{$t('m.yjcx')}}</template>
	    <el-menu-item index="/fclbysea">{{$t('m.hyzx')}}</el-menu-item>
	    <el-menu-item index="/lclbysea">{{$t('m.hypx')}}</el-menu-item>
	    <el-menu-item index="/byair">{{$t('m.ky')}}</el-menu-item>
			<el-menu-item index="/railroad">{{$t('m.t.tl')}}</el-menu-item>
			<el-menu-item index="/trailer">{{$t('m.t.nltc')}}</el-menu-item>
			<el-menu-item index="/express">{{$t('m.t.gjkd')}}</el-menu-item>
	  </el-submenu>
	  <el-menu-item index="/us" class="right">{{$t('m.CompanyText')}}</el-menu-item>
	  <el-menu-item index="/contact" class="right">{{$t('m.Contact')}}</el-menu-item>

	  
	  <div style="padding: 20px;" class="right">
	  		  <el-dropdown @command="handleCommand">
	  		    <span class="el-dropdown-link">
	  		    {{language}}<i class="el-icon-arrow-down el-icon--right"></i>
	  		    </span>
	  		    <span class="el-dropdown-link">
	  		     
	  		    </span>
	  		    <el-dropdown-menu slot="dropdown">
	  		      <el-dropdown-item command="zh-CN">{{zhOption}}</el-dropdown-item>
	  		      <el-dropdown-item command="en-US">{{enOption}}</el-dropdown-item>
	  		    </el-dropdown-menu>
	  		  </el-dropdown>
	  		  </div>
			  
			  <el-menu-item index="/login" class="right"> 
			  <span>{{$t('m.selectLogin')}}</span>
			  <el-button type="primary"   style="margin-left: 5px;">{{$t('m.regLogin')}}</el-button>
			  </el-menu-item> 
			 
		
			 <div class="right1">
				 <div style="font-size:30px; color: black;" @click="isCollapseClick">
				 <i class="el-icon-s-unfold"></i>
				 </div>
				  </div>
			 
	</el-menu>
	</div>
	      </div>	

<!-- 手机端 -->
<div class="left-menu">

<el-menu 
style=" overflow: auto; overflow-x: hidden;"
  v-if="tokenStr"
  router
 text-color="#000000"
 	:default-active="$route.path"
 	active-text-color="#409EFF"
 class="el-menu-vertical-demo" 
 @open="handleOpen" 
 @close="handleClose" 
 :collapse="isCollapse"
 @select="handleSelectPhone"
 >
 <el-menu-item index="/home">
   <span slot="title">{{$t('m.HomeText')}}</span>
 </el-menu-item>
				    <el-submenu index="/yunjia">
				      <template slot="title"> 
				        <span slot="title">{{$t('m.yjcx')}}</span>
				      </template>
				     <el-menu-item index="/fclbysea">{{$t('m.hyzx')}}</el-menu-item>
				     <el-menu-item index="/lclbysea">{{$t('m.hypx')}}</el-menu-item>
				     <el-menu-item index="/byair">{{$t('m.ky')}}</el-menu-item>
				     	<el-menu-item index="/railroad">{{$t('m.t.tl')}}</el-menu-item>
				     	<el-menu-item index="/trailer">{{$t('m.t.nltc')}}</el-menu-item>
				     	<el-menu-item index="/express">{{$t('m.t.gjkd')}}</el-menu-item>
				    </el-submenu>
					  <el-menu-item index="/entrustment"><span slot="title">{{$t('m.t.wtjl')}}</span></el-menu-item>
				  <el-menu-item index="/us"><span slot="title">{{$t('m.CompanyText')}}</span></el-menu-item>
				  <el-menu-item index="/contact"><span slot="title">{{$t('m.Contact')}}</span></el-menu-item>
				  
				<!-- 后台管理系统 -->
				<el-submenu index="sjcdhtglxt" v-if="menusChildren.length>=1 && menusChildren[0].Fid !== null" >
				    <template slot="title"><span slot="title">{{$t('m.htglxt')}}</span></template>
					<template v-for="item in menusChildren">
				    <el-menu-item
				    :index="item.indexPath"
				    :key="item.indexPath"
					v-if="item.children.length===0"
					>{{item.label}}
					</el-menu-item>
					
					<el-submenu
					:index="item.indexPath"
					:key="item.indexPath"
					v-else
					>
					<template slot="title">{{item.label}}</template>
					<el-menu-item
					:key="subItem.indexPath"
					:index="subItem.indexPath" 
					v-for="subItem in item.children" >
					{{subItem.label}}
					</el-menu-item>
					</el-submenu>
					</template>
				  </el-submenu>
				  <!-- 个人中心 -->
				  <el-submenu index="grzx">
				     <template slot="title">
				        <span>{{$t('m.grzx')}}</span>
				      </template>
				  <el-menu-item index="/userAllInfo"
				     ><i class="el-icon-s-operation"></i>{{$t('m.myCenterText')}}
					 </el-menu-item
				   >
				     <el-menu-item index="/userInfo"
				        ><i class="el-icon-edit-outline"></i>{{$t('m.xgMyInfo')}}</el-menu-item
				      >
				      <el-menu-item index="/userAvatar"
				        ><i class="el-icon-camera"></i>{{$t('m.ghtx')}}</el-menu-item
				      >
				      <el-menu-item index="/userPwd"
				        ><i class="el-icon-key"></i>{{$t('m.zzmm')}}</el-menu-item
				      >
				    </el-submenu> 
				  <div style="padding: 20px;">
				  		  <el-dropdown @command="handleCommand">
				  		    <span class="el-dropdown-link">
				  		    {{language}}<i class="el-icon-arrow-down el-icon--right"></i>
				  		    </span>
				  		    <span class="el-dropdown-link">
				  		     
				  		    </span>
				  		    <el-dropdown-menu slot="dropdown">
				  		      <el-dropdown-item command="zh-CN">{{zhOption}}</el-dropdown-item>
				  		      <el-dropdown-item command="en-US">{{enOption}}</el-dropdown-item>
				  		    </el-dropdown-menu>
				  		  </el-dropdown>
				  		  </div>
				  <el-menu-item   @click="logout"><span slot="title">{{$t('m.out')}}</span></el-menu-item>
				  </el-menu>
<!-- 没有登录 -->
 <el-menu 
v-else
  router
 text-color="#000000"
 	:default-active="$route.path"
 	active-text-color="#409EFF"
 class="el-menu-vertical-demo" 
 @open="handleOpen" 
 @close="handleClose" 
 :collapse="isCollapse"
 @select="handleSelectPhone"
 >
 <el-menu-item index="/home">
   <span slot="title">{{$t('m.HomeText')}}</span>
 </el-menu-item>
				    <el-submenu index="/yunjia">
				      <template slot="title"> 
				        <span slot="title">{{$t('m.yjcx')}}</span>
				      </template>
				     <el-menu-item index="/fclbysea">{{$t('m.hyzx')}}</el-menu-item>
				     <el-menu-item index="/lclbysea">{{$t('m.hypx')}}</el-menu-item>
				     <el-menu-item index="/byair">{{$t('m.ky')}}</el-menu-item>
				     	<el-menu-item index="/railroad">{{$t('m.t.tl')}}</el-menu-item>
				     	<el-menu-item index="/trailer">{{$t('m.t.nltc')}}</el-menu-item>
				     	<el-menu-item index="/express">{{$t('m.t.gjkd')}}</el-menu-item>
				    </el-submenu>
				  <el-menu-item index="/us"><span slot="title">{{$t('m.CompanyText')}}</span></el-menu-item>
				  <el-menu-item index="/contact"><span slot="title">{{$t('m.Contact')}}</span></el-menu-item>

				  <div style="padding: 20px;" :class="isCollapse == true ? 'languagestyle' :''">
				  		  <el-dropdown @command="handleCommand">
				  		    <span class="el-dropdown-link">
				  		    {{language}}<i class="el-icon-arrow-down el-icon--right"></i>
				  		    </span>
				  		    <span class="el-dropdown-link">
				  		    </span>
				  		    <el-dropdown-menu slot="dropdown">
				  		      <el-dropdown-item command="zh-CN">{{zhOption}}</el-dropdown-item>
				  		      <el-dropdown-item command="en-US">{{enOption}}</el-dropdown-item>
				  		    </el-dropdown-menu>
				  		  </el-dropdown>
				  		  </div>
						  
						  <el-menu-item index="/login">
							  <span slot="title">
						 {{$t('m.regLogin')}}
						 </span>
						  </el-menu-item> 
				  </el-menu>


</div>










<!-- 返回顶部箭头 -->
  <div :class="topBack == true ? 'topBackShow' :'topBackHidden'" >
    <img src="../assets/img/toup.png"
    alt=""
    width="50px"
    height="50px"
    @click="backtop"
    :style="active"
    @mouseover="mouseOver"
    @mouseleave="mouseLeave"
    >
  </div>
  
  <!-- 客服窗口 -->
  <div 
  v-if="customer_rating ==2 ||  customer_rating ==3 ||  customer_rating ==0"
  :class="tokfck == true ? 'kfshow5' :'kfnone'"
  >
 <div>
	<img src="../assets/img/zskf.png" alt=""  width="280px" height="133px" style="position: absolute;z-index: -100;"/>
	<div style="display: flex;margin-left: 5px;" >
		 <div style="display: flex;flex-direction: column;margin-top: 20px;text-align: center;">
			 <div></div>
	 <div style="margin-left: 0px;margin-top: 5px;"><img :src="this.yesnokf == true ? this.kf_wx_code : this.xs_wx_code " alt="" width="80px" height="80px"/></div>
	  <div style="font-weight: bold;padding: 2px 0;">{{$t('m.kf.addwx')}}</div>
	 </div>
	 <div style="margin-left: 5px;font-size: 13px;margin-top: 60px;">
		 	 <span class="popover-item" style="margin-top: -60px;border-bottom: 3px solid #256DB3;">
				 <div style="display: flex;flex-direction: column;">
				 <div :style="{'margin-left':(this.$i18n.locale =='zh-CN' ? '115px':'80px')}">
			   <el-button @click="qh" size="mini" round plain style="font-size: 12px;background: #409EFF;color:white;margin-left: 0px;">{{this.yesnokf == true ? $t('m.card.qhxs') : $t('m.card.qhkf')}}</el-button>
			   </div>
			   <div>
			  <span style="font-weight: bold;font-size: 15px;"> {{this.yesnokf == true ? $t('m.card.Customerservice') : $t('m.card.Sales')}} — {{this.yesnokf == true ? (this.kf_username == null ? $t('m.card.dfp') : this.kf_username) : this.xs_username}}</span>
			   </div>
			   </div>
			 </span>
			
		<div style="margin-top: 0px;width: 180px;">
	<!-- <span class="popover-item"><div class="yxbjt"><i class="iconfont icon--telephone"  style="margin-left: 4px;margin-top: 4px;position: absolute;"></i> </div> <span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{this.yesnokf == true ?  (this.kf_username == null ? $t('m.card.dfp') : this.kf_landline) : this.xs_landline}}</span></span> -->
	 
	 <span class="popover-item"><div  class="yxbjt"><i class="iconfont icon-dianhua" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i> </div>  <span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{this.yesnokf == true ?  (this.kf_username == null ? $t('m.card.dfp') : this.kf_phone) : this.xs_phone}}</span>
	 </span>
	<span class="popover-item" style="word-break: break-all;
        word-wrap: break-word"><div  class="yxbjt"><i class="iconfont icon-youxiang" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i> </div><span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{this.yesnokf == true ? (this.kf_username == null ? $t('m.card.dfp') : this.kf_email) : this.xs_email}}</span></span>
	<span class="popover-item"><div  class="yxbjt"><i class="iconfont icon-qq" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i></div>
	
	<el-link :href="`https://wpa.qq.com/msgrd?v=3&uin=${this.yesnokf == true ?  (this.kf_username == null ? $t('m.card.dfp') : this.kf_qq) : this.xs_qq}&site=qqq&menu=yes`" target="_blank" >
		<span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{this.yesnokf == true ?  (this.kf_username == null ? $t('m.card.dfp') : this.kf_qq) : this.xs_qq}}</span> 
		</el-link> 
	</span>
 	</div>	 	
 </div>
 </div>
</div>


  </div>
  
  <!-- 游客卡片 -->
  <div
    v-if="!tokenStr"
    :class="tokfck == true ? 'kfshow2' :'kfnone'"
    >
   <div>
  	<img src="../assets/img/zskf.png" alt=""  width="280px" height="130px" style="position: absolute;z-index: -100;"/>
  	<div style="display: flex;margin-left: 5px;" >
  		 <div style="display: flex;flex-direction: column;margin-top: 20px;text-align: center;">
  	 <div>
		 <img src='../assets/img/leo.jpg' alt="" width="80px" height="80px" v-if="this.$i18n.locale =='zh-CN'"/>
		 <img src='../assets/img/lillian.jpg' alt="" width="80px" height="80px" v-else/>
	 </div>
  	 <div style="font-weight: bold;padding: 2px 0;">{{$t('m.kf.addwx')}}</div>
  	 </div>
  	 <div style="margin-left: 5px;font-size: 13px;margin-top: 45px;">
  		 	 <span class="popover-item" style="margin-top: -40px;border-bottom: 3px solid #256DB3;">
  				 <div style="display: flex;flex-direction: column;">
  				 
  			   <div>
  			  <span style="font-weight: bold;font-size: 15px;"> {{$t('m.card.Customerservice')}} — {{$t('m.kf.name1')}}</span>
  			   </div>
  			   </div>
  			 </span>
  			
  		<div style="margin-top: 10px;width: 190px;">
  	 <span class="popover-item"><div  class="yxbjt"><i class="iconfont icon-dianhua" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i> </div>  <span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.tel1')}}</span>
  	 </span>
  	<span class="popover-item" style="word-break: break-all;
          word-wrap: break-word"><div  class="yxbjt"><i class="iconfont icon-youxiang" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i> </div><span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.email1')}}</span></span>
  	<span class="popover-item">
		<div  class="yxbjt">
			<i class="iconfont icon-qq" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i></div>
			<el-link :href="`https://wpa.qq.com/msgrd?v=3&uin=${$t('m.kf.qq1')}&site=qqq&menu=yes`" target="_blank" >
				<span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.qq1')}}</span>
				</el-link> 
			
		</span>
   	</div>	 	
   </div>
   </div>
  </div>
  
  
    </div>
  <div
    v-if="!tokenStr"
    :class="tokfck == true ? 'kfshow1' :'kfnone'"
    >
   <div>
  	<img src="../assets/img/zskf.png" alt=""  width="270px" height="130px" style="position: absolute;z-index: -100;"/>
  	<div style="display: flex;margin-left: 5px;" >
  		 <div style="display: flex;flex-direction: column;margin-top: 20px;text-align: center;">
  	 <div ><img src='../assets/img/polo.jpg' alt="" width="80px" height="80px"/></div>
  	 <div style="font-weight: bold;padding: 2px 0;">{{$t('m.kf.addwx')}}</div>
  	 </div>
  	 <div style="margin-left: 5px;font-size: 13px;margin-top: 45px;">
  		 	 <span class="popover-item" style="margin-top: -40px;border-bottom: 3px solid #256DB3;">
  				 <div style="display: flex;flex-direction: column;">
  				 
  			   <div>
  			  <span style="font-weight: bold;font-size: 15px;"> {{$t('m.card.Customerservice')}} — {{$t('m.kf.name2')}}</span>
  			   </div>
  			   </div>
  			 </span>
  			
  		<div style="margin-top: 10px;width: 180px;">
  	 <span class="popover-item"><div  class="yxbjt"><i class="iconfont icon-dianhua" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i> </div>  <span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.tel2')}}</span>
  	 </span>
  	<span class="popover-item" style="word-break: break-all;
          word-wrap: break-word"><div  class="yxbjt"><i class="iconfont icon-youxiang" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i> </div><span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.email2')}}</span></span>
  	<span class="popover-item"><div  class="yxbjt"><i class="iconfont icon-qq" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i></div>
	<!-- <span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.qq2')}}</span> -->
	<el-link :href="`https://wpa.qq.com/msgrd?v=3&uin=${$t('m.kf.qq2')}&site=qqq&menu=yes`" target="_blank" >
		<span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.qq2')}}</span>
		</el-link> 
	 </span>
   	</div>	 	
   </div>
   </div>
  </div>
  
  
    </div>
  <div
    v-if="!tokenStr"
    :class="tokfck == true ? 'kfshow' :'kfnone'"
    >
   <div>
  	<img src="../assets/img/zskf.png" alt=""  width="270px" height="130px" style="position: absolute;z-index: -100;"/>
  	<div style="display: flex;margin-left: 5px;" >
  		 <div style="display: flex;flex-direction: column;margin-top: 20px;text-align: center;">
  	 <div> 
	 <img src='../assets/img/Kitty.jpg' alt="" width="80px" height="80px" v-if="this.$i18n.locale =='zh-CN'"/>
		 <img src='../assets/img/Angela.jpg' alt="" width="80px" height="80px" v-else/></div>
  	 <div style="font-weight: bold;padding: 2px 0;">{{$t('m.kf.addwx')}}</div>
  	 </div>
  	 <div style="margin-left: 5px;font-size: 13px;margin-top: 45px;">
  		 	 <span class="popover-item" style="margin-top: -40px;border-bottom: 3px solid #256DB3;">
  				 <div style="display: flex;flex-direction: column;">
  				 
  			   <div>
  			  <span style="font-weight: bold;font-size: 15px;"> {{$t('m.card.Customerservice')}} — {{$t('m.kf.name3')}}</span>
  			   </div>
  			   </div>
  			 </span>
  			
  		<div style="margin-top: 10px;width: 180px;">
  	 <span class="popover-item"><div  class="yxbjt"><i class="iconfont icon-dianhua" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i> </div>  <span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.tel3')}}</span>
  	 </span>
  	<span class="popover-item" style="word-break: break-all;
          word-wrap: break-word"><div  class="yxbjt"><i class="iconfont icon-youxiang" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i> </div><span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.email3')}}</span></span>
  	<span class="popover-item"><div  class="yxbjt"><i class="iconfont icon-qq" style="margin-left: 4px;margin-top: 4px;position: absolute;"></i></div>
	<!-- <span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.qq3')}}</span> -->
	<el-link :href="`https://wpa.qq.com/msgrd?v=3&uin=${$t('m.kf.qq3')}&site=qqq&menu=yes`" target="_blank" >
		<span style="margin-top: 4px;margin-left: 10px;font-weight: bold;">{{$t('m.kf.qq3')}}</span>
		</el-link> 
	</span>
   	</div>	 	
   </div>
   </div>
  </div>
  
  
    </div>
  
  
  
  
  
  
  
  
</div>

</template>

<script>
import { mapGetters } from 'Vuex'
export default {
  data() {
    return {
	  yesnokf:true,
	  lang:'zh-CN',
	  language:this.$t('m.xzyy'),
	  zhOption:this.$t('m.zhongwen'),
	  enOption:this.$t('m.yingwen'),
      menus:[],
      navBarFixed:false,
      topBack:false,
	  tokfck:true,
      active:'height:50px;width:50px;',
	  activeKf:'position: fixed;right: -20px;bottom: 400px;z-index: 100;cursor: pointer;',
	  isCollapse:true
    };
  },
  computed: {//从vuex的getters里面拿
    ...mapGetters(['username','user_pic','nickname','id','menusChildren','kf_username','kf_phone','kf_email','kf_landline','kf_qq','kf_wx_code','xs_username','xs_phone','xs_email','xs_landline','xs_qq','xs_wx_code','customer_rating']),
	tokenStr(){
		return window.sessionStorage.getItem('token')
	},
  },
  mounted(){
	// console.log(this.$route.path)
	
	 if(this.$route.path == '/home'){
		 this.tokfck = true
	 }else if (this.$route.path == '/fclbysea'){
		 this.tokfck = true
	 }else if(this.$route.path == '/lclbysea'){
		 this.tokfck = true
	 }else if(this.$route.path == '/byair'){
		 this.tokfck = true
	 }else if(this.$route.path == '/railroad'){
		 this.tokfck = true
	 }else if(this.$route.path == '/trailer'){
		 this.tokfck = true
	 }else if(this.$route.path  == '/express'){
				this.tokfck = true
			}
	 
	 
	 
	 
	 else{
		  this.tokfck = false
	 }
	 
 window.addEventListener('scroll', this.watchScroll)
  },
 created() {
	this.handleSelect()
	this.tokfck = true
	
	
	   //    document.addEventListener('click', function (e) {
	   //    let flag = e.target.contains(document.getElementsByClassName('left-menu')[0])
		  
	   //    console.log(flag)
	   //    if(!flag) return
	   //    this.isCollapse = false
	       
	   //    })
	
	
	
  },
  methods: {
qh(){
	this.yesnokf = !this.yesnokf
	console.log(this.yesnokf)
},
  
    handleSelect(key, keyPath) {
		//console.log(key, keyPath)
			//路由界指向监听
            // console.log(key);
			if(key == '/home' ){
				this.tokfck = true
			}else if(key == '/fclbysea'){
				this.tokfck = true
			}else if(key == '/lclbysea'){
				this.tokfck = true
			}else if(key == '/byair'){
				this.tokfck = true
			}else if(key == '/railroad'){
				this.tokfck = true
			}else if(key == '/trailer'){
				this.tokfck = true
			}else if(key == '/express'){
				this.tokfck = true
			}
			
			else{
				this.tokfck = false
			}
          },

     watchScroll () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
           // console.log(scrollTop)
			  const offsetTop = document.querySelector('.swiper_con').offsetTop //观察容器距离顶部的高度
            //  当滚动超过 50 时，实现吸顶效果
            if (scrollTop > offsetTop) {
              this.navBarFixed = true
              this.topBack=true
            } else {
              this.navBarFixed = false
               this.topBack=false
            }
         },
         //返回顶部
         backtop(){
       let top = document.documentElement.scrollTop || document.body.scrollTop
       // 实现滚动效果，平缓滑到头部
       const timeTop = setInterval(() => {
         document.body.scrollTop = document.documentElement.scrollTop = top -= 50
         if (top <= 0) {
           clearInterval(timeTop)
         }
       }, 10)
         },
  mouseOver(){
           this.active='height:53px;width:53px;';
         },
  mouseLeave() {
            this.active = 'height:50px;width:50px;';
           },
    logout(){
      // 询问用户是否退出登录
        this.$confirm(this.$t('m.logout.tcdl'), this.$t('m.logout.ts'), {
          confirmButtonText: this.$t('m.logout.confirm'),
          cancelButtonText: this.$t('m.logout.cancel'),
          type: 'warning',
					lockScroll:false
        }).then(() => {
        // // TODO：执行退出登录的操作
        // 1. 清空 token
        //window.sessionStorage.clear()清除所有token
        //window.sessionStorage.removeItem('token', res.token)
        // 2. 跳转到登录页面
       // this.$router.push('/login')
		this.$router.push('/home')
        window.sessionStorage.clear()
        location.reload();
        //dispatch：含有异步操作，例如向后台提交数据，写法： this.$store.dispatch('action方法名',值)
            //commit：同步操作，写法：this.$store.commit('mutations方法名',值)
        //退出登录把，vuex状态机数据清空
        this.$store.commit('updateUserInfo',{})
        this.$store.commit('updateMenu',[])
         this.$message({
                   type: 'success',
                   message: '退出登录成功!'
                 });
          }).catch(()=>{
      	//  this.$message({
      	//            type: 'info',
      	//         message: '已取消退出登录'
      	// });
      })

    },
	handleCommand(command) {
	  this.lang = command
	 // console.log(this.lang)
	  if(this.lang == 'zh-CN'){
					   this.$store.commit('updateLanguage',this.lang)
					   location.reload();
	  }else{  
					   this.$store.commit('updateLanguage',this.lang)
					   location.reload();
					   
	  }
	  
	   },
	   
	     handleOpen(key, keyPath) {
	           console.log(key, keyPath);
	         },
	         handleClose(key, keyPath) {
	           console.log(key, keyPath);
	         },
			 isCollapseClick(){
				this.isCollapse = !this.isCollapse
			 },
			 handleSelectPhone(){
				 this.isCollapse = true
			 }
	     
  },
};
</script>

<style lang="scss" scoped>
// 使用在线iconfont图标资源
@import url(//at.alicdn.com/t/c/font_4358597_gk1s1vktyvs.css);

//最小屏幕宽度，大于1280px
@media screen and (min-width: 1280px) {
.kfshow{
	border-radius: 10px;
	-moz-box-shadow:2px 2px 10px #CCC;
	-webkit-box-shadow:2px 2px 10px #CCC;
	box-shadow:2px 2px 10px #CCC;
	position: fixed;
	left: 50%;
	// top: 50%;
	transform: translate(127%); 
	
	top: 70px;
	//right: 10%;
	z-index: 100;
	cursor: pointer;
}
.kfshow1{
	border-radius: 10px;
	-moz-box-shadow:2px 2px 10px #CCC;
	-webkit-box-shadow:2px 2px 10px #CCC;
	box-shadow:2px 2px 10px #CCC;
	position: fixed;
	left: 50%;
	// top: 50%;
	transform: translate(20%); 
	
	top: 70px;
	//right: 10%;
	z-index: 100;
	cursor: pointer;
}
.kfshow2{
	border-radius: 10px;
	-moz-box-shadow:2px 2px 10px #CCC;
	-webkit-box-shadow:2px 2px 10px #CCC;
	box-shadow:2px 2px 10px #CCC;
	position: fixed;
	left: 50%;
	// top: 50%;
	transform: translate(-87%); 
	
	top: 70px;
	//right: 10%;
	z-index: 100;
	cursor: pointer;
}
.kfshow5{
border-radius: 10px;
	-moz-box-shadow:2px 2px 10px #CCC;
	-webkit-box-shadow:2px 2px 10px #CCC;
	box-shadow:2px 2px 10px #CCC;
	position: fixed;
	left: 50%;
	// top: 50%;
	transform: translate(123%); 
	
	top: 70px;
	//right: 10%;
	z-index: 100;
	cursor: pointer;	
}
.pc .el-menu{
  width: 100%;
  display: flex;
  justify-content: center; /* 水平居中 */
  height: 65px;
  color: #000000;
}
	.right1 {
	  display:none
	 }
	 .left{
		 display: flex;
	 }
	 .logostyle{
		font-weight: bold;
		font-size: 20px; 
	 }
	 .ywmz{
	 	//浏览器最小字体只能12px
	 margin-top: 5px;
	 transform: scale(0.57);
	 transform-origin: 0 0; 
	 }
	.ZHimg{
		margin-top: 10px;
		z-index: 99;
		margin-left: -60px;
		margin-right: 60px;
		position: relative;
		width: 50px;
		height: 45px;
	}
.lefttext{
	display: flex;
	flex-direction: column;
	margin-top: 15px;
	margin-left: -50px;
	margin-right: -140px;
}
.topBackShow{
 display: block;
 position: fixed;
 right: 50px;
 bottom: 70px;
 z-index: 999;
 cursor: pointer;
}
.topBackHidden{
  display: none;
}
	.left-menu{
		display: none;
	}
}
//小于1280px大于400px
@media screen and (max-width: 1280px) and  (min-width: 390px) {
	.kfshow{
		display: none;
	}
	.kfshow1{
	display: none;
	}
	.kfshow2{
	display: none;
	}
	.kfshow5{
display: none;
	}
	.pc .el-menu{
	  width: 100%;
	  display: flex;
	  justify-content: space-between;
	  height: 65px;
	  color: #000000;
	}
	.right{
		display: none;
	}
	.right1 {
	  display:flex;
	  align-items: center;
	 }
	 .left{
	 		 display: flex;
	 }
	 .logostyle{
		 font-weight: bold;
	 }
	 .ywmz{
	 	//浏览器最小字体只能12px
	 margin-top: 5px;
	font-size: 10px;
	 }
	 .ZHimg{
	 	margin-top: 10px;
	 	z-index: 99;
	 	margin-left: -60px;
	 	margin-right: 60px;
	 	position: relative;
	 	width: 45px;
	 	height: 40px;
	 }
	.lefttext{
		display: flex;
		flex-direction: column;
		margin-top: 15px;
		margin-left: -50px;
		margin-right: -140px;
		
	} 
	.topBackShow{
	 display: none
	}
	.topBackHidden{
	  display: none;
	}
	.left-menu .el-menu-vertical-demo{
		position: fixed;
		width: 0px;
	}
	 .left-menu  .el-menu-vertical-demo:not(.el-menu--collapse) {
		 z-index: 1000;
		 position: fixed;
	    width: 200px;
	   height: 100%;
	  }
	.languagestyle {
		 display: none;
	}
	
}


//最大屏幕宽度，小于400px
@media screen and (max-width: 390px) {
	.kfshow{
		display: none;
	}
	.kfshow1{
	display: none;
	}
	.kfshow2{
	display: none;
	}
	.kfshow5{
display: none;
	}
	.pc .el-menu{
	  width: 100%;
	  display: flex;
	  justify-content: space-between;
	  height: 65px;
	  color: #000000;
	}
	.right{
		display: none;
	}
	.right1 {
	  display:flex;
	  align-items: center;
	 }
	 .left{
	 		 display: flex;
	 }
	 .logostyle{
		 font-weight: bold;
	 }
	 .ywmz{
	 	//浏览器最小字体只能12px
	 margin-top: 5px;
	font-size: 10px;
	 }
	 .ZHimg{
	 	margin-top: 10px;
	 	z-index: 99;
	 	margin-left: -60px;
	 	margin-right: 60px;
	 	position: relative;
	 	width: 45px;
	 	height: 40px;
	 }
	.lefttext{
		display: flex;
		flex-direction: column;
		margin-top: 15px;
		margin-left: -50px;
		margin-right: -190px;
	} 
	.topBackShow{
	 display: none
	}
	.topBackHidden{
	  display: none;
	}
.left-menu .el-menu-vertical-demo{
	position: fixed;
		width: 0px;
	}
	.left-menu  .el-menu-vertical-demo:not(.el-menu--collapse) {
		z-index: 1000;
		position: fixed;
    width: 200px;
    height: 100%;
  }
  
 .languagestyle {
	 display: none;
 }
  
}










::v-deep .el-card__body{
padding: 0;	
}

.kfnone{
	display: none;
}
::v-deep  .el-card__header{
	padding: 0px 10px;
}
.popover-item{
	display: flex;
	padding: 2px;
}
.el-button, .el-dropdown {
    color: #000000;
    font-size: 14px;
}
.navBarWrap {
    position:fixed;
     top:0px;
	 left: 0px;
    z-index:999;
    width: 100%;
  }

.avatar {
  border-radius: 50%;
  width: 35px;
  height: 35px;
  background-color: #fff;
  margin-top: 10px;
  object-fit: cover;
}

::v-deep .el-menu .el-menu-item:hover{
    color: #2E95FB !important;

}


.yxbjt{
	width: 25px;
	height: 25px;
	background-color: #256DB3;
	border-radius: 50%;
	color: white;
}

::v-deep .el-card__header {
   border-bottom: none;
}

.ywmz{
	//浏览器最小字体只能12px
margin-top: 5px;
transform: scale(0.57);
transform-origin: 0 0; 
}
.el-button--mini, .el-button--mini.is-round {
    padding: 3px 7px;
}


</style>
